export default "__VITE_ASSET__CDuQujWc__"